// live chat
export const CHANGE_VISIBILITY = "CHANGE_VISIBILITY";
